import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useCallback, useMemo } from 'react';
import DropdownMenu from '@jetbrains/ring-ui/components/dropdown-menu/dropdown-menu';
import Button from '@jetbrains/ring-ui/components/button/button';
import chevronDown from '@jetbrains/icons/chevron-down';
import Icon from '@jetbrains/ring-ui/components/icon';
import classNames from 'classnames';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import styles from './plugin-rules-list-wrapper.css';
export function PluginRulesListWrapper(props) {
    const { onCreateRule, legacyFeatureType, children, isRestrictedMode } = props;
    const options = useMemo(() => [
        {
            label: 'All plugins',
            key: 'all-plugins',
            ruleType: 'all-plugins',
            restrictedCompatible: false,
            ...assignTestId('all-plugins')
        },
        {
            label: 'Plugins from corporate repository',
            key: 'internal-repo',
            ruleType: 'internal-repo',
            restrictedCompatible: false,
            ...assignTestId('internal-repo')
        },
        {
            label: 'Plugins from selected vendor',
            key: 'vendor-plugins',
            ruleType: 'vendor-plugins',
            restrictedCompatible: false,
            ...assignTestId('vendor-plugins')
        },
        {
            label: 'Specific plugin',
            key: 'single-plugin',
            ruleType: 'single-plugin',
            restrictedCompatible: true,
            ...assignTestId('single-plugin')
        }
    ].filter(item => (isRestrictedMode ? item.restrictedCompatible : true)), [isRestrictedMode]);
    const handleSelect = useCallback((item) => onCreateRule(item.ruleType), [onCreateRule]);
    const renderAnchor = useCallback((props, ariaProps) => {
        const { active } = props;
        return _jsx(DropdownMenuHandle, { open: active, ...ariaProps });
    }, []);
    return (_jsxs("div", { children: [Children.count(children) > 0 && _jsx("div", { className: styles.rules, children: children }), !legacyFeatureType && (_jsx(DropdownMenu, { ...assignTestId('crete-new-rule-dropdown'), className: styles.dropdown, anchor: renderAnchor, onSelect: handleSelect, data: options })), legacyFeatureType && (_jsx(Button, { className: styles.dropdown, ...assignTestId('create-new-rule-btn'), onClick: () => onCreateRule('single-plugin'), children: "Add new plugin" }))] }));
}
function DropdownMenuHandle(props) {
    const { open, ...restProps } = props;
    return (_jsxs(Button, { ...restProps, children: ["Add rule", _jsx(Icon, { className: classNames(styles.chevron, { [styles.open]: open }), glyph: chevronDown })] }));
}
